import React, { createContext, useState } from "react";

export const DevicesContext = createContext();

export const DevicesProvider = ({ children }) => {
  const [devicesList, setDevicesList] = useState([
    { id: 1, brand: "Apple", model: "iPhone 14", description: "Yeni nesil telefon" },
    { id: 2, brand: "Samsung", model: "Galaxy S23", description: "Android cihaz" },
  ]);

  // Cihaz ekleme
  const addDevice = (device) => {
    const newId =
      devicesList.length > 0 ? Math.max(...devicesList.map((d) => d.id)) + 1 : 1;
    setDevicesList((prev) => [...prev, { ...device, id: newId }]);
  };

  // Cihaz güncelleme
  const updateDevice = (id, updatedData) => {
    setDevicesList((prev) =>
      prev.map((d) => (d.id === id ? { ...d, ...updatedData } : d))
    );
  };

  // Cihaz silme
  const deleteDevice = (id) => {
    setDevicesList((prev) => prev.filter((d) => d.id !== id));
  };

  return (
    <DevicesContext.Provider
      value={{
        devicesList,
        addDevice,
        updateDevice,
        deleteDevice,
      }}
    >
      {children}
    </DevicesContext.Provider>
  );
};
